/**
 * Page links — single source of truth for all user-facing pages.
 *
 * Consumed by AdminLayout.jsx for the sidebar quick-links.
 * When adding a new page/route, add it here — the admin sidebar
 * picks it up automatically.
 */
export const PAGE_LINKS = [
  { label: 'Home', href: '/' },
  { label: 'Blog', href: '/blog' },
  { label: 'About', href: '/about' },
  { label: 'Pricing', href: '/pricing' },
  { label: 'Redeem Code', href: '/redeem' },
  { label: 'Chat', href: '/chat' },
  { label: 'Login', href: '/login' },
  { label: 'Welcome', href: '/welcome' },
  { label: 'Subscribe', href: '/subscribe' },
  { label: 'Feedback', href: '/feedback' },
  { label: 'Payment Success', href: '/payment-success' },
  { label: 'Privacy Policy', href: '/privacy' },
  { label: 'Terms of Service', href: '/terms' },
  { label: 'Support', href: '/support' },
  { label: 'Changelog', href: '/changelog' },
  { label: 'Dashboard (Home)', href: '/home' },
  { label: 'Learn', href: '/learn' },
  { label: 'Achievements', href: '/learn/achievements' },
  { label: 'Prayer', href: '/prayer' },
  { label: 'Prayer Journal', href: '/prayer?tab=journal' },
  { label: 'Bible', href: '/bible' },
  { label: 'Account', href: '/account' },
  { label: 'Ministry Map', href: '/ministry-map' },
  { label: 'Admin — Content Studio', href: '/admin/studio' },
  { label: 'Admin — Blog Pipeline', href: '/admin/blog-pipeline' },
  { label: 'Admin — Features', href: '/admin/features' },
  { label: 'Admin — AI Automations', href: '/admin/automations' },
  { label: 'Admin — Bio Links', href: '/admin/links' },
]
